import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { balanceObj, userObj } from 'components/common/requestBody';
import { getBalance } from 'redux/solde/getBalanceSlice';
import translationKeys from 'translations/translationKeys';
import fileText from '../../../../assets/images/mathys/svg/fileText.svg';

const Solde = () => {
  const { agentId, agentPwd } = useSelector((store) => store.login);
  const { successGetBalance } = useSelector((store) => store.balance);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [date, setDate] = useState('');
  const handleChange = () => {
    setDate(document.getElementById('datelabel').value);
  };

  const disabled = () => (date === '');

  const handleSubmit = (e) => {
    e.preventDefault();
    const dateObject = new Date(date);
    const timestamp = dateObject.getTime();
    dispatch(getBalance({
      ...balanceObj,
      date: timestamp,
      uuid: agentId,
      agentPwd,
      imei: userObj.imei,
      ime: userObj.imei,
    }));
  };

  const {
    msg20, msg63, msg55, msg195,
  } = translationKeys;

  useEffect(() => {
    if (successGetBalance) {
      setDate('');
    }
  },
  [successGetBalance]);

  return (
    <div className="details history">
      <div className="header">
        <img src={fileText} alt="" />
        <span>{t(msg20)}</span>
      </div>
      <div className="content">
        <form action="" onSubmit={handleSubmit} className="solde-form" id="journal-sold-form">
          <div className="content-grid">
            <div className="input-wrap">
              <label htmlFor="datelabel">
                {t(msg63)}
              </label>
              <input
                type="date"
                className={`form-control solde-input${!disabled() ? ' has-value' : ''}`}
                value={date}
                id="datelabel"
                placeholder={t(msg195)}
                onChange={handleChange}
                required
              />
            </div>
            <button
              type="submit"
              className="btn btn-secondary"
              disabled={disabled()}
            >
              <span>{t(msg55)}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Solde;
